import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=4a90c5ed"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=4a90c5ed&prod&lang=css"
import style1 from "./AppFooter.vue?vue&type=style&index=1&id=4a90c5ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports